module.exports = __webpack_public_path__ + "img/acu.cad75a83.png";